import { render } from "./TipButton.vue?vue&type=template&id=17cdefca"
import script from "./TipButton.vue?vue&type=script&lang=js"
export * from "./TipButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__